import { render, staticRenderFns } from "./projects-analysis.vue?vue&type=template&id=3c47240c&scoped=true&"
import script from "./projects-analysis.vue?vue&type=script&lang=js&"
export * from "./projects-analysis.vue?vue&type=script&lang=js&"
import style0 from "./projects-analysis.vue?vue&type=style&index=0&id=3c47240c&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47240c",
  null
  
)

export default component.exports